<div class="quick-apply-header">
  <div class="header-container">
    <div class="logo-container">
      <div id="aq-logo" class="logo">
        <svg-icon src="../../../assets/images/logos/Aquent_Skill_Lockup_Black.svg"></svg-icon>
      </div>
    </div>
    <h3 *ngIf="getHeaderText()" id="overline" class="overline">{{getHeaderText()}}</h3>
    <h2 *ngIf="headerText" id="header-text" class="header-text">
      {{headerText}}
    </h2>
  </div>
</div>
